import React, { FC } from 'react';
import styled from '@emotion/styled';

interface AsymmetricColumnLayoutProps {
  left: React.ReactNode;
  right: React.ReactNode;
  ratio?: [number, number];
}

const FlexGrid = styled.div<{ ratio: [number, number] }>`
  display: grid;
  grid-template-columns: ${({ ratio }) => `${ratio[0]}fr ${ratio[1]}fr`};
  gap: ${({ theme }) => theme.padding.l};
  height: 100%;
  overflow: scroll;
  min-width: 0;
  min-height: 0;
`;

const Column = styled.div`
  min-width: 0;
  min-height: 0;
  overflow: auto;
`;

const AsymmetricColumnLayout: FC<AsymmetricColumnLayoutProps> = ({ left, right, ratio = [1, 2] }) => {
  return (
    <FlexGrid ratio={ratio}>
      <Column>{left}</Column>
      <Column>{right}</Column>
    </FlexGrid>
  );
};

export default AsymmetricColumnLayout;
